import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  Chip,
  Divider,
  Alert
} from '@mui/material';
import {
  Error as ErrorIcon,
  Description as DescriptionIcon,
  Category as CategoryIcon,
  Close as CloseIcon
} from '@mui/icons-material';

const ValidationErrorModal = ({ open, onClose, errors }) => {
  const { missingSections = [], missingDescriptions = [] } = errors;
  const totalErrors = missingSections.length + missingDescriptions.length;

  if (totalErrors === 0) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <ErrorIcon color="error" sx={{ mr: 1 }} />
            <Typography variant="h6">Validation Errors Found</Typography>
          </Box>
          <Chip 
            label={`${totalErrors} error${totalErrors > 1 ? 's' : ''}`} 
            color="error" 
            size="small" 
          />
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Please fix the following issues before proceeding with bid preparation.
        </Alert>

        {missingSections.length > 0 && (
          <>
            <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
              <CategoryIcon color="primary" sx={{ mr: 1 }} />
              <Typography variant="h6">Missing Section Names</Typography>
            </Box>
            <List dense>
              {missingSections.map((error, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <ErrorIcon color="error" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="body2">
                        <strong>Item #{error.itemIndex} ({error.itemName})</strong>
                      </Typography>
                    }
                    secondary={`Section ${error.sectionTitle} has missing section name`}
                  />
                </ListItem>
              ))}
            </List>
            <Divider sx={{ my: 2 }} />
          </>
        )}

        {missingDescriptions.length > 0 && (
          <>
            <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
              <DescriptionIcon color="primary" sx={{ mr: 1 }} />
              <Typography variant="h6">Missing Descriptions</Typography>
            </Box>
            <List dense>
              {missingDescriptions.map((error, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <ErrorIcon color="error" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="body2">
                        <strong>{error.item}</strong>
                      </Typography>
                    }
                    secondary={
                      error.type === 'PURPOSE_DESCRIPTION_MISSING'
                        ? 'Purpose description is missing'
                        : `${error.section} - ${error.requirement} - Description is missing`
                    }
                  />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </DialogContent>
      
      <DialogActions>
        <Button 
          onClick={onClose} 
          startIcon={<CloseIcon />}
          variant='outlined'
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidationErrorModal;